import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import CheckoutCodeService from '../services/checkoutCodeService';

const CheckoutCodeInput = () => {
  const [enteredCheckoutCode, setEnteredCheckoutCode] = useState('');
  const [checkoutCodeError, setCheckoutCodeError] = useState('');

  const { dispatch } = useOutletContext();

  const checkoutCodeService = new CheckoutCodeService();

  const handleUpdatePromoCode = (e) => {
    setEnteredCheckoutCode(e.target.value);
  };

  const handleSubmitPromoCode = async (e) => {
    e.preventDefault();
    setCheckoutCodeError('');
    if (enteredCheckoutCode.trim() !== '') {
      try {
        const { data } = await checkoutCodeService.validateCheckoutCode(enteredCheckoutCode);
        dispatch({ type: 'ADD_ACTIVE_CODE', payload: data });
      } catch (error) {
        if (error.response?.data?.error) {
          setCheckoutCodeError(error.response.data.error);
        } else {
          setCheckoutCodeError('There was an error processing your code.');
        }
      }
      // When we want to diplay the zero payment box, we have to clear the credit card fields
      //   // so that if we were to render the payment info again the validation would rerun.
      //   if (amountOwed === 0) clearCardFields();
    }
    setEnteredCheckoutCode('');
  };

  return (
    <>
      <div style={{ display: 'flex' }}>
        <input type="text" placeholder="Enter Promo Code" value={enteredCheckoutCode} onChange={handleUpdatePromoCode} style={{ flexGrow: 2, marginBottom: 0 }} />
        <button type="button" className="button button--soft" style={{ marginLeft: '1rem' }} onClick={handleSubmitPromoCode}>Apply</button>
      </div>
      {checkoutCodeError && (
        <p className="form-error__message" dangerouslySetInnerHTML={{ __html: checkoutCodeError }} />
      )}
    </>
  );
};

export default CheckoutCodeInput;
